<div class="attachments">
  <h6>
    Всего {{ createLabel(damItemVersions?.length, 'версия|версии|версий') }}
    <input nbInput fieldSize="small" placeholder="Поиск" i18n-placeholder="@@SearchVersion" (keyup)="filterSidebarFilter($event)"/>
  </h6>


  <div class="attachments-checkboxes">
    <ng-container *ngFor="let file of fileExtensions; index as i">
      <nb-checkbox (checkedChange)="onFileExtensionToggle(i)">
        {{ file?.typeOfFile }}
        <nb-badge [text]="file?.count"/>
      </nb-checkbox>
    </ng-container>
  </div>

  <div class="attachments-list" *ngIf="damItemVersions?.length" cdkDropList (cdkDropListDropped)="drop($event)">

    <ng-container *ngFor="let version of filterVersions(damItemVersions)">
      <ng-container *ngIf="version?.hideExpression==undefined || version.hideExpression==false">

        <div class="attachments-item" [ngClass]="{'active': version.id === currentVersion.id}" (click)="selectVersion(version)" cdkDrag>
          <div class="attachments-item__row">
            <div class="attachments-item__img-container">
              <app-secured-image *ngIf="damService.showThumbnail(version.mimeType)" src="/dam/get-image-dynamic-version/{{version.id}}"/>
              <img *ngIf="!damService.showThumbnail(version.mimeType)" style="max-width: 50px;object-fit: contain;width: 100%;height: 100%;" src="/assets/images/vivid/{{damService.getExtension(version)}}.svg" alt=""/>
            </div>

            <div class="props">
              <b>
                {{ version.header }}
                <a nbButton (click)="modalRename(version)" nbTooltip="Переименовать" status="control">
                  <nb-icon icon="edit-outline"/>
                </a>
              </b>

              <ng-container *ngTemplateOutlet="VersionAnnotation; context: { version: version }"/>

              <div class="buttons">
                <button nbButton size="small" (click)="download(version.id, version.header)">
                  <span i18n="@@Download">Скачать</span>
                </button>
                <button nbButton size="small" (click)="getExif(version.id, version?.iid); windowService.open(ExifDialog)">
                  Exif
                </button>

                <a nbButton size="small" (click)="getHistory(version); windowService.open(VersionHistoryDialog);" i18n="@@ProductChanges">
                  История изменений
                </a>
              </div>
            </div>

          </div>
        </div>

      </ng-container>
    </ng-container>
  </div>
</div>

<div class="attachments-list" *ngIf="!damItemVersions?.length">
  <div>Версий не найдено</div>
</div>

<ng-template #ExifDialog>
  <h2><span i18n="@@VersionExif">Exif данные версии</span>&nbsp;{{ exifIid }} </h2>

  <div class="dialog-list">
    <ng-container *ngIf="documentExifList?.length; else noExif">
      <div class="exif-item" *ngFor="let exif of documentExifList">
        <div>{{ exif.tag }}</div>
        <div>{{ exif.description }}</div>
        <div>{{ exif.directory }}</div>
      </div>
    </ng-container>

    <ng-template #noExif>
      <div i18n="@@ExifIsMissing">Exif отсутствует</div>
    </ng-template>
  </div>
</ng-template>

<ng-template #VersionHistoryDialog>
  <h6 i18n="@@History">История версий элемента {{ clickedDamItemVersion.id }}</h6>

  <app-uploader (upload)="onUpload($event)" [hideDescription]="true"/>

  <div class="dialog-list">
    <ng-container *ngIf="damItemVersions?.length; else noVersion">
      <div class="version-item" *ngFor="let version of versionsHistory;">

        <app-secured-image *ngIf="damService.showThumbnail(version.mimeType)" src="/dam/get-image-dynamic-version-history/{{version.id}}"/>
        <img *ngIf="!damService.showThumbnail(version.mimeType)" style="max-width:100px" src="/assets/images/vivid/{{damService.getExtension(version)}}.svg" alt="">

        <div class="version-item-info">

          <h6>{{ version.header }}</h6>

          <ng-container *ngTemplateOutlet="VersionAnnotation; context: { version: version }"/>

          <div>
            @if (clickedDamItemVersion.documentId === version.documentId) {
              <button type="button" class="is-actual" nbButton size="small">
                Актуальная версия
              </button>
            } @else {
              <a *ngIf="write" (click)="makeActual(version.id)" nbButton size="small">Сделать версию актуальной</a>
            }
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noVersion>
      <h6>Нет версий </h6>
    </ng-template>
  </div>
</ng-template>

<ng-template #VersionAnnotation let-version="version">
  <nb-actions size="small">
    <nb-action>
      <span [ngClass]="version?.header.split('.').pop()">.{{ version?.header.split('.').pop() }}</span>
    </nb-action>
    <nb-action>
      {{ version?.size | formatSize }}
    </nb-action>
    <nb-action nbTooltip="Дата создания">
      {{ version.createdAt | date : 'dd.MM.yyyy HH:mm:ss' }}
    </nb-action>
  </nb-actions>
</ng-template>
